import { CaretDown } from "@phosphor-icons/react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { visibleRolesLabel } from "../lib/roles";

export default function RolesPicker({ roles, value, onChange, testId }) {
  const vr = value?.length ? value : ["todos"];
  const isAll = vr.includes("todos");
  const toggle = (id) => {
    if (id === "todos") { onChange(["todos"]); return; }
    const base = isAll ? [] : vr;
    const next = base.includes(id) ? base.filter((x) => x !== id) : [...base, id];
    onChange(next.length ? next : ["todos"]);
  };
  const Option = ({ id, label }) => (
    <label className="flex items-center gap-2 px-2 py-1.5 rounded-lg hover:bg-[var(--bg)] cursor-pointer text-sm">
      <input
        type="checkbox"
        checked={id === "todos" ? isAll : !isAll && vr.includes(id)}
        onChange={() => toggle(id)}
        data-testid={`${testId}-opt-${id}`}
        className="w-4 h-4 accent-[var(--primary)]"
      />
      {label}
    </label>
  );
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          title="Visibilidad por rol"
          className="inline-flex items-center gap-2 px-3 py-2 rounded-xl border border-[var(--border)] bg-white text-sm font-display max-w-[220px]"
        >
          <span className="truncate">{visibleRolesLabel(roles, vr)}</span>
          <CaretDown size={12} />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-56 p-2" align="start">
        <div className="label-cap px-2 mb-1">visible para</div>
        <Option id="todos" label="Todos" />
        <div className="h-px bg-[var(--border)] my-1" />
        {roles.map((r) => <Option key={r.id} id={r.id} label={r.name} />)}
      </PopoverContent>
    </Popover>
  );
}
